export const HUB_SPOT_COOKIE_NAMES = [
  'hubspotutk',
  'messagesUtk',
  '__hstc',
  '__hssc',
  '__hssrc',
  '__hs_do_not_track',
  '__hs_initial_opt_in',
  '__hs_cookie_cat_pref',
  '__hsmem',
  'hs-messages-is-open',
  'hs-messages-hide-welcome-message',
  'hs-messages-scroll-position',
  'hs-messages-is-reload',
];
